import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { ViewTermsAndPoliciesModalPage } from './view-terms-and-policies-modal.page';
import { TermsAndPoliciesPageModule } from 'src/app/terms-and-policies/terms-and-policies.module';

const routes: Routes = [
  {
    path: '',
    component: ViewTermsAndPoliciesModalPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),
    TermsAndPoliciesPageModule
  ],
  declarations: [    
    ViewTermsAndPoliciesModalPage
  ]
})
export class ViewTermsAndPoliciesModalPageModule {}
